import React, { useEffect, useState } from "react";
import apartment from "../../../assets/img/create/buildings.svg";
import village from "../../../assets/img/create/house-2.svg";
import boomgardi from "../../../assets/img/create/house.svg";
import hotel from "../../../assets/img/create/buliding.svg";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import Button from "../../shared/Button";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
const CreateStep1 = ({ prevStep, nextStep }) => {
  const {
    updatePlaceDetail,
    createInfoData,
    updatePlace,
    setIsEditPlaceCompleter
  } = useCreatePlace();

  const [idcat, setIdcat] = useState(createInfoData.stepOne.category);
  const arr = [
    {
      id: "apartment",
      title: "آپارتمانی",
      des: "( آپارتمان و سوئییت )",
      img: apartment
    },
    {
      id: "villa",
      title: "ویلایی و باغ",
      des: "( ویلا ، خانه سنتی و ... )",
      img: village
    },
    {
      id: "ecotourism_collection",
      title: "مجموعه بوم گردی",
      des: "( خانه روستایی ، کلبه و ... )",
      img: boomgardi
    },
    {
      id: "hotel",
      title: "هتل و مهمان پذیر",
      des: "( هتل ، پانسیون و ... )",
      img: hotel
    }
  ];
  const submitToNext = () => {
    if (idcat === "") {
      toast.error("دسته بندی اجباری است.");
    } else {
      updatePlaceDetail("stepOne", {
        category: idcat
      });
      nextStep();
    }
  };
  const { id } = useParams();
  useEffect(
    () => {
      setIdcat(createInfoData.stepOne.category);
    },
    [createInfoData]
  );
  const update = () => {
    updatePlaceDetail("stepOne", {
      category: idcat
    });
    setIsEditPlaceCompleter(true);
    
  };
  return (
    <div className="CreateStep1 createsteps">
      <h2>دســتــه بــنــدی</h2>
      <p>
        اقامتگاه شما در کدام یک از دسته بندی های زیر قرار دارد ؟ از بین
        گزینه‌های زیر، نوع اقامتگاهی که می‌خواهید ثبت کنید را انتخاب کنید.
      </p>
      <div className="CreateStep1--grid">
        {arr.map(i =>
          <div
            onClick={() => setIdcat(i.id)}
            className={`CreateStep1Card  cursor-pointer ${i.id === idcat
              ? "CreateStep1Card--active"
              : ""}`}
          >
            <img src={i.img} />
            <h4>
              {i.title}
            </h4>
            <p>
              {i.des}
            </p>
          </div>
        )}
      </div>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
        {/* <Button
                varient="gray"
                onClick={() => {
                  if (currentPhase !== 1) {
                    prevStep();
                  }
                }}
              >
                مرحله قبلی
              </Button> */}
        {id && <Button varient="primary" onClick={update}>بروزرسانی اقامتگاه</Button>}

        <Button varient="primary" onClick={() => submitToNext()}>
          مرحله بعدی
        </Button>
      </div>
    </div>
  );
};

export default CreateStep1;
